import { render, staticRenderFns } from "./Problem.vue?vue&type=template&id=5bd1c152&scoped=true&"
import script from "./Problem.vue?vue&type=script&lang=ts&"
export * from "./Problem.vue?vue&type=script&lang=ts&"
import style0 from "./Problem.vue?vue&type=style&index=0&id=5bd1c152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1c152",
  null
  
)

export default component.exports